package ui.showcase.showcases

import adapters.Api
import react.FC
import react.dom.html.ReactHTML
import react.useContext
import react.useEffectOnce
import react.useState
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.ApiReturns
import ru.malygin.myConst.ErrorCode
import ui.component.MainScreenComponents
import ui.component.tabs.Tabs
import ui.new_ui.components.loaders.linear_loaders.LinearLoader
import ui.styles.Styles
import ui.themePlusContext.MyContext
import ui.themePlusContext.ToastContext
import ui.themePlusContext.ToastData
import ui.themePlusContext.ToastTypes

val MainScreen = FC{
//    document.title = RouterRoute.MAIN_SCREEN.title ?: document.title

    //todo
//    val loaderData = getFromLoader<TestSealed>()
//    log.i("[MainScreen] loaderData: $loaderData")
    //

    val ctx = useContext(MyContext)
    val toast = useContext(ToastContext)

    var receivedList: List<MainScheduleItemDto>? by useState(null)
    val mapOfGroups = receivedList?.map {
        it.groupName
    }?.distinct()

    var currentGroupForTutor by useState<String?>(mapOfGroups?.first())

    var errorMessage:String? by useState(null)
    var alertHandler by useState(false)


    fun alertCh(erMsg:String?){
        if (erMsg.isNullOrEmpty()){
            alertHandler = false
            errorMessage = null
        }else{
            alertHandler = true
            errorMessage = erMsg
        }
    }


    useEffectOnce {

        when(val ret = Api().getMainList(
            groupName = ctx.name,
            category = ctx.category
        )){
            is ApiReturns.Error -> {
                alertCh(ret.code.message)

                when{
                    (ret.code == ErrorCode.INCORRECT_PARAMETERS_ERROR) ||
                            (ret.code == ErrorCode.SERVER_ERROR) ||
                            (ret.code == ErrorCode.NO_DATA_ERROR)-> {
                        toast.open(
                            ToastData(
                                message = ret.code.message,
                                type = ToastTypes.ERROR,
                                timeout = 6000
                            )
                        )
                    }
                    else -> Unit
                }
            }
            is ApiReturns.Success -> {
                alertCh(null)
                receivedList = ret.data
            }
            else -> {}
        }
    }

//    log.d("[MainScreen] map of groups ${mapOfGroups.toString()}")

    val msComponents = MainScreenComponents(
        receivedList = receivedList,
        category = ctx.category,
        selectedGroupForTutor = currentGroupForTutor,
        selectedGroupsListForTutor = mapOfGroups
    )

    var activeTab by useState(
        msComponents.days.indexOfFirst { tdi->
            tdi.targetDay == 1
        }.takeIf { it != -1 } ?: 0
    )

    //--------------------------------------------------------------------------------

    ReactHTML.div{
        className = Styles.MainScreenComp.mainScreenCmp

        /**
         * ERROR
         */
        ReactHTML.div{
            className = Styles.MainScreenComp.msError

            LinearLoader{
                isLoading = errorMessage.isNullOrEmpty() && receivedList.isNullOrEmpty()
            }
        }


        /**
         * HEAD
         */
        ReactHTML.div{
            className = Styles.MainScreenComp.msHead

            msComponents.mainScreenTutorGroupsSelector{
                this.onChange = {
                    currentGroupForTutor = it
                }
            }

            receivedList?.let {

                Tabs(
                    groupedReceivedList = msComponents.groupedReceivedList,
                    activeTab = activeTab,
                    onActiveTabChange = {
                        activeTab = it
                    }
                ).tabsHead()
            } ?: run {
                msComponents.onLoadingSkeletonHead()
            }
        }


        /**
         * MAIN
         */
        ReactHTML.div{
            className = Styles.MainScreenComp.msMain

            Tabs(
                groupedReceivedList = msComponents.groupedReceivedList,
                activeTab = activeTab,
                onActiveTabChange = {
                    activeTab = it
                }
            ).tabsBody{
                this.category = ctx.category
                this.selectedGroupForTutor = currentGroupForTutor?:""
            }
        }
    }

}